import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader
} from "../../../../_metronic/_partials/controls";
import { getAnswersByScenario } from "../../../../api/answer";
import { getGroups } from "../../../../api/group";
import { getSceneById } from "../../../../api/scene";
import { alertError } from "../../../../utils/logger";
import Table, {
	pointsFormatter,
	timeFormatter
} from "../../../components/tables/table";

function getData(groups, answers) {
	let data = [];
	groups.forEach((group) => {
		let groupAnswers = answers.filter((answer) => {
			return answer.group === group._id;
		});
		let result = null;
		if (groupAnswers.length) {
			/**
			 * ⚠️ answer.time no es “duración del quiz”; en el resto del backoffice se trata como
			 * tiempo acumulado del grupo (o marca de tiempo) al responder.
			 * Si lo SUMAMOS, el tiempo se infla (p.ej. 36 min) aunque el juego esté limitado a 20.
			 *
			 * Para ranking por escenario queremos:
			 * - puntos: suma de scores
			 * - tiempo: el “último / mayor” time registrado dentro del escenario
			 */
			result = groupAnswers.reduce(
				(acc, curr) => ({
					score: (acc.score || 0) + (curr.score || 0),
					time: Math.max(acc.time || 0, curr.time || 0),
				}),
				{ score: 0, time: 0 }
			);
		}
		if (result) {
			data = data.concat({
				group: group.fullName,
				pts: result.score,
				time: result.time,
			});
		}
	});

	data.sort((a, b) => {
		if (a.pts !== b.pts) {
			return b.pts - a.pts;
		}
		return a.time - b.time;
	});
	return data;
}

export default function ViewScenePage() {
	const [data, setData] = useState([]);
	const [scenario, setScenario] = useState();
	const [refresh, setRefresh] = useState(false);
	const sceneId = useParams().id;

	const columns = [
		{ dataField: "group", text: "Group" },
		{
			dataField: "pts",
			text: "Correct",
			align: "center",
			headerAlign: "center",
			formatter: pointsFormatter,
			sort: true,
		},
		{
			dataField: "time",
			text: "Time",
			align: "center",
			headerAlign: "center",
			formatter: timeFormatter,
			sort: true,
		},
	];

	useEffect(() => {
		getSceneById(sceneId)
			.then((res) => {
				if (res.status === 200) {
					setScenario(res.data);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get the scenario.",
				});
			});

		getAnswersByScenario(sceneId)
			.then((resAnswers) => {
				if (resAnswers.status === 200) {
					getGroups()
						.then((res) => {
							if (res.status === 200) {
								setData(getData(res.data, resAnswers.data));
								setRefresh(false);
							}
						})
						.catch((error) => {
							alertError({
								error: error,
								customMessage: "Could not get groups.",
							});
						});
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get groups.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader
					title={`Scenario | ${scenario?.fullName || ""}`}
				></CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
				</CardBody>
			</Card>
		</>
	);
}
